'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".login__background, .login__layout__background--bottom, .login__layout__background--top {\n  display: flex;\n  position: absolute;\n  flex: 1;\n  width: 100%;\n}\n.login__layout {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n}\n.login__layout__content {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 30px;\n}\n.login__layout__background--top {\n  height: 275px;\n  top: 0;\n  background-color: #1d66dd;\n}\n@media (max-width: 768px) {\n  .login__layout__background--top {\n    height: 174px;\n  }\n}\n.login__layout__background--bottom {\n  bottom: 0;\n}");
//# sourceMappingURL=LoginLayout.scss.js.map
